import style from "./style.module.sass"
import SemiCircleProgressBar from "react-progressbar-semicircle"
import React from "react"
import { useTheme } from "@material-ui/core/styles"
import { useTranslation } from "react-i18next"
import { convertNumberToStringLocally } from "../../../../utils"
import { useSelector } from "react-redux"
import config from "../../../../config"

export default function CLIXWrapperAi({ clix, target, tabIndex }) {
    const { theme: { bgColors, borderColors, colors } } = useTheme()
    const { t, i18n: { language: i18nLanguage } } = useTranslation()
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
    
    const isContrast = themeState !== config.THEMES_MODES.LIGHT
    const percentage = clix
    const color = clix < target / 2 ? "#dd0d08" : clix < target ? "#da7d27" : "#a8c721"
    return (
        <div className={style.bars} style={{ height:'99px', backgroundColor: bgColors.bgPrimary100}} tabIndex={tabIndex} title={t("accessibility_analysis_clix")}>
            <p className={`m-0 ${style.bar_title}`} style={{ color: isContrast ? colors.colorContrast : colors.colorPrimary500 }}>{t("ai_gen_clix")}</p>
            <SemiCircleProgressBar diameter={115} percentage={percentage} background={bgColors.bgClixBar} stroke={isContrast ? bgColors.bgCockpitBar : color} strokeWidth={8} />
            <div className={style.progressDesc} style={{top: '38px'}}>
                <p style={{ color: isContrast ? colors.colorContrast : colors.colorPrimary500 }} className={`m-0 ${style.title}`}>{t("CLIX_analysis_minidash")}</p>
                <p className={`m-0 ${style.percentage}`} style={{ color: colors.colorPrimary1000 }}>{convertNumberToStringLocally(clix, i18nLanguage)}</p>
                <div style={{ borderColor: borderColors.borderPrimary1000 }}
                    className={`${style.maxSize} d-flex justify-content-center`}>
                    <p style={{ color: isContrast ? colors.colorContrast : colors.colorPrimary500 }} className={`m-0 ${style.zielwert}`}>{t("Target value")}:</p>
                    <p className={`m-0 ${style.zielwertNum} ml-1`} style={{ color: colors.colorText }}>{convertNumberToStringLocally(target, i18nLanguage)}</p>
                </div>
            </div>
        </div>
    )
}